import { render, staticRenderFns } from "./ProductFiles.vue?vue&type=template&id=45fc3646&scoped=true&"
import script from "./ProductFiles.vue?vue&type=script&lang=js&"
export * from "./ProductFiles.vue?vue&type=script&lang=js&"
import style0 from "./ProductFiles.vue?vue&type=style&index=0&id=45fc3646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc3646",
  null
  
)

export default component.exports